import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Loading from './widgets/Loading'
import { store } from '../store'
import { push } from 'react-router-redux'
import {
    CATEGORY_UPDATE_LOADED,
    CATEGORY_UPDATE_UNLOADED,
    CATEGORY_UPDATE,
    CATEGORY_DELETE,
    REDIRECT
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.category,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: CATEGORY_UPDATE_LOADED, payload }),
    onSubmit: (payload) => {
        dispatch({ type: CATEGORY_UPDATE, payload })
    },
    onUnload: () =>
        dispatch({ type: CATEGORY_UPDATE_UNLOADED }),
    onDelete: (payload) =>
        dispatch({ type: CATEGORY_DELETE, payload }),
    onRedirect: () =>
        dispatch({ type: REDIRECT })
});

class CategoryEdit extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (name) => ev => {
            ev.preventDefault();
            const payload = agent.Categories.updateCategory(this.props.match.params.key, name)
            this.props.onSubmit(payload);
        }
        this.delete = () => ev => {
            ev.preventDefault()
            const payload = agent.Categories.deleteCategory(this.props.match.params.key)
            this.props.onDelete(payload)
        }
    }
    componentWillMount() {
        this.props.onLoad(agent.Categories.getDetail(this.props.match.params.key));
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.updated === true || nextProps.removed === true) {
            store.dispatch(push('/categories/user/' + nextProps.category.userkey))
            this.props.onRedirect()
        }
        if (nextProps.category) {
            Object.assign(this.state, {
                name: nextProps.category.name,
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.category) {
            return (
                <Loading />
            )
        }
        const name = this.state.name;

        return (
            <div class='pane'>
                <Link className="crumb" to={`/category/${this.props.category.key}/detail`}>&laquo; back to detail</Link>

                <h1>Update category</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(name)}>
                    <fieldset className="form">
                        <strong>Name</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={this.updateState('name')} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Update
                            </button>
                            <button
                                type="button"
                                onClick={this.delete()}
                                disabled={this.props.inProgress}>
                                Delete
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CategoryEdit);



// WEBPACK FOOTER //
// ./src/components/CategoryEdit.js